import { render, staticRenderFns } from "./CatalogueBrowser.vue?vue&type=template&id=79f48172&"
import script from "./CatalogueBrowser.vue?vue&type=script&lang=js&"
export * from "./CatalogueBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports